// @flow
import React from "react";
import { connect } from "react-redux";
import { useI18n } from "@quantum/i18n";
import SelecaoIndicesEBenchmarksPersonalizados from "./SelecaoIndicesEBenchmarksPersonalizados";
import {
  type ActionCreator,
  selecionarIndice,
  selecionarPrimeiroIndice,
  getIndiceSelecionado,
} from "../../../../state";

type Prop = {
  indiceSelecionado: string,
  datasIndiceSelecionado: string,
  selecionarIndice: ActionCreator,
  selecionarPrimeiroIndice: ActionCreator,
};

function SelecaoIndice({
  indiceSelecionado,
  selecionarPrimeiroIndice,
  datasIndiceSelecionado,
  selecionarIndice,
}: Prop) {
  const { translate } = useI18n();

  function handleIndiceSelecionado(indice) {
    selecionarIndice(indice);
  }

  return (
    <div>
      <SelecaoIndicesEBenchmarksPersonalizados
        labelSelecao={translate("maiusculas.indice")}
        indiceSelecionado={indiceSelecionado}
        onChange={handleIndiceSelecionado}
        selecionarPrimeiroIndice={selecionarPrimeiroIndice}
        selecionarIndice={selecionarIndice}
      />
    </div>
  );
}

export default connect(
  state => ({
    indiceSelecionado: getIndiceSelecionado(state),
  }),
  { selecionarIndice, selecionarPrimeiroIndice }
)(SelecaoIndice);
